import { IconName } from "@components/AnimalCard";

export const typeOrder: IconName[] = [
    "dog",
    "cat",
    "fish",
    "bird",
    "reptile",
    "smallMammal",
    "other",
  ];

  export const otherTypeOrder: IconName[] = [
    "bird",
    "reptile",
    "smallMammal",
    "other",
  ];

  /**
 * Accepted file types for document upload
 */
export const ACCEPTED_FILE_TYPES = {
  pdf: "application/pdf",
  jpeg: "image/jpeg",
  jpg: "image/jpeg",
  png: "image/png",
} as const;

export const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB

export const WARING_DAYS = 5 // days before expiry to show warning

export const tenantTimeLineSteps = [
        { label: 'About You' },
        { label: 'Your Pets' },
        { label: 'Your Co-Tenants' },
    ];